import { Store } from '@src/application/store/store';
import { StateDefinition } from '@src/application/store/state-definition';
import { LegacyStore } from '@src/application/store/legacy-store-interface.ts';

// wird in app.vue gesetzt
const store = new Store({
    isMobile: new StateDefinition(false, false),
});

export default store as unknown as LegacyStore<boolean>;
